module.exports = __webpack_public_path__ + "static/media/p2s.3e876518.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/p2s.png
// module id = 265
// module chunks = 0